module.exports = __webpack_public_path__ + "img/img28.d63a76aa.png";